import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AppProvider } from './context/AppContext'
import { AdminPage } from './pages/AdminPage'
import { BrandPage } from './pages/BrandPage'
import { CommunityPage } from './pages/CommunityPage'
import { FlashPage } from './pages/FlashPage'
import { GuidePage } from './pages/GuidePage'
import { HomePage } from './pages/HomePage'
import { LiveReportsPage } from './pages/ReportsPage'

export default function App(){return <BrowserRouter><AppProvider><Routes><Route path="/" element={<HomePage/>}/><Route path="/brand" element={<BrandPage/>}/><Route path="/flash" element={<FlashPage/>}/><Route path="/recommendations" element={<GuidePage/>}/><Route path="/reports" element={<CommunityPage/>}/><Route path="/live-reports" element={<LiveReportsPage/>}/><Route path="/admin" element={<AdminPage/>}/><Route path="*" element={<Navigate to="/"/>}/></Routes></AppProvider></BrowserRouter>}
